require('./bootstrap');
import 'alpinejs';
import '@fortawesome/fontawesome-free/css/all.min.css';
